module.exports = __webpack_public_path__ + "static/media/long-arrow-alt-left.87b9658c.svg";